export default {
  nav: {
    about: {
      en: 'About',
    },
    blog: {
      en: 'Blog',
    },
    rulesAndDisclaimers: {
      en: 'Rules & Disclaimers',
    },
    terms: {
      en: 'Terms & Conditions',
    },
    policy: {
      en: 'Privacy Policy',
    },
  },
}
